var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product__selections" },
    [
      _c("product-variations", {
        ref: "productVariations",
        attrs: { attributes: _vm.attributes, variations: _vm.variations },
        on: { change: _vm.variationsChanged }
      }),
      _vm._v(" "),
      _c("product-mandatory-add-ons", {
        ref: "productMandatoryAddOns",
        attrs: {
          "add-ons": _vm.mandatoryProductAddOns,
          "hide-prices": _vm.hidePrices
        },
        on: { change: _vm.mandatoryAddOnsChanged }
      }),
      _vm._v(" "),
      _c("product-add-ons", {
        ref: "productAddOns",
        attrs: { "add-ons": _vm.productAddOns, "hide-prices": _vm.hidePrices },
        on: { change: _vm.addOnsChanged }
      }),
      _vm._v(" "),
      _vm.view != "modal"
        ? _c("div", { staticClass: "product__availability-container" }, [
            _vm.availability
              ? _c(
                  "p",
                  {
                    staticClass: "availability",
                    class: _vm.availability.status
                      ? "availability--" + _vm.availability.status
                      : ""
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.availability.text) + "\n      "
                    ),
                    _vm.availability.detail
                      ? _c("span", { staticClass: "availability__detail" }, [
                          _vm._v(_vm._s(_vm.availability.detail))
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.inShowroom
              ? _c(
                  "p",
                  { staticClass: "availability availability--positive" },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$modeoL10n.in_showroom) +
                        "\n      "
                    ),
                    _c("span", { staticClass: "availability__detail" }, [
                      _vm._v(_vm._s(_vm.$modeoL10n.in_showroom_disclaimer))
                    ])
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showPrice
        ? _c(
            "div",
            { staticClass: "product__price-container price-container" },
            [
              _vm.hasSelections()
                ? _c("div", { staticClass: "product__price-heading" }, [
                    _c(
                      "span",
                      { staticClass: "product__price-heading__text" },
                      [_vm._v(_vm._s(_vm.$modeoL10n.in_total))]
                    ),
                    _vm._v("\n      ("),
                    _c(
                      "button",
                      {
                        staticClass: "link",
                        on: {
                          click: function($event) {
                            return _vm.clearSelections()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$modeoL10n.clear_selections) +
                            "\n      "
                        )
                      ]
                    ),
                    _vm._v(")\n    ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "price price--big" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "price-amount-container price-amount-container--big"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "price-amount product__price-amount",
                        class: {
                          "price-amount--ins":
                            _vm.total_price_with_tax !=
                            _vm.total_regular_price_with_tax
                        }
                      },
                      [
                        _c("price", {
                          attrs: {
                            "price-with-tax": _vm.total_price_with_tax,
                            "price-without-tax": _vm.total_price_without_tax
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.total_price_with_tax != _vm.total_regular_price_with_tax
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "price-amount price-amount--del product__price-amount"
                          },
                          [
                            _c("price", {
                              attrs: {
                                "price-with-tax":
                                  _vm.total_regular_price_with_tax,
                                "price-without-tax":
                                  _vm.total_regular_price_without_tax
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "price-details price-details--big" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "tax tax--big",
                        class: {
                          "tax--highlight tax--highlight-big":
                            _vm.product.outlet &&
                            !_vm.$store.getters.showPricesWithVat
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$modeoL10n.vat) +
                            " " +
                            _vm._s(_vm.$store.getters.displayVat)
                        )
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.disableBuying
                      ? [
                          _c("product-counter", {
                            ref: "productCounter",
                            attrs: {
                              "counter-mode": "big",
                              "max-count": _vm.maxCount()
                            },
                            on: {
                              update: function($event) {
                                return _vm.addToCartWithCount($event)
                              },
                              change: function($event) {
                                return _vm.changeCount($event)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.orderType == "order"
                            ? _c(
                                "button",
                                {
                                  staticClass: "product__buy btn btn--buy",
                                  attrs: { disabled: _vm.addToCartDisabled },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.addToCart()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$modeoL10n.buy) +
                                      "\n          "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.orderType == "offer" && _vm.view != "modal"
                            ? _c(
                                "button",
                                {
                                  staticClass: "product__buy btn btn--buy",
                                  attrs: { disabled: _vm.addToCartDisabled },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.addToCart()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$modeoL10n.add) +
                                      "\n          "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$modeoL10n.url_rfp && _vm.disableBuying
        ? _c("div", { staticClass: "conversion-mini" }, [
            _c("div", { staticClass: "conversion-mini__content-column" }, [
              _c("h2", { staticClass: "conversion-mini__heading" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$modeoL10n.ask_more_about_product) +
                    "\n      "
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "btn btn--secondary btn--secondary-med btn--secondary-forward conversion-mini__button",
                attrs: {
                  href:
                    _vm.$modeoL10n.url_rfp +
                    "?tuote=" +
                    encodeURI(
                      _vm.$modeoL10n.interested_in_following_products +
                        ": " +
                        _vm.product.name
                    )
                }
              },
              [_vm._v(_vm._s(_vm.$modeoL10n.contact_us))]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("klarna-placement", {
        attrs: {
          "data-key": "credit-promotion-badge",
          "data-locale": _vm.klarnaLocale(),
          "data-preloaded": "true",
          "data-purchase-amount": this.$store.getters.showPricesWithVat
            ? _vm.total_price_with_tax * 100
            : parseInt(_vm.total_price_without_tax * 100)
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f732fc6", { render: render, staticRenderFns: staticRenderFns })
  }
}